import ReactGA from 'react-ga';

const trackingId = 'UA-145485174-3';

ReactGA.initialize(trackingId);

export default ReactGA;
